import html2canvas from 'html2canvas';

export const captureScreenshot = options =>
  html2canvas(document.body, {
    background: '#fff',
    scale: 0.5,
    logging: false,
    ...options
  }).then(canvas => canvas.toDataURL('image/jpeg'));
